import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatCredExpInfo as creatCredExpInfoApi,
    updateCredExpInfo as updateCredExpInfoApi,
    getAllCredExpInfo as getAllCredExpInfoApi,
    getCredExpInfo as getCredExpInfoApi,
} from './api';

// actions
import { credExpInfoApiResponseSuccess, credExpInfoApiResponseError } from './actions';

// constants
import { CredExpInfoActionTypes } from './constants';

type CredExpInfoData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Cred Expiry
 * @param {*}
 */
function* addCredExpInfo({ payload, type }: CredExpInfoData): SagaIterator {
    try {
        const response = yield call(creatCredExpInfoApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                credExpInfoApiResponseSuccess(
                    CredExpInfoActionTypes.ADD_CRED_EXP_INFO,
                    data,
                    'Cred Expiry has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Cred Expiry!`;
            if (message) msg = message;
            yield put(
                credExpInfoApiResponseSuccess(CredExpInfoActionTypes.ADD_CRED_EXP_INFO, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(credExpInfoApiResponseError(CredExpInfoActionTypes.ADD_CRED_EXP_INFO, [], error, 404, true, false));
    }
}

/**
 * Edit Cred Expiry
 * @param {*}
 */
function* editCredExpInfo({ payload, type }: CredExpInfoData): SagaIterator {
    try {
        const response = yield call(updateCredExpInfoApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                credExpInfoApiResponseSuccess(
                    CredExpInfoActionTypes.EDIT_CRED_EXP_INFO,
                    data,
                    'Cred Expiry Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Cred Expiry!`;
            if (message) msg = message;
            yield put(
                credExpInfoApiResponseSuccess(CredExpInfoActionTypes.EDIT_CRED_EXP_INFO, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(credExpInfoApiResponseError(CredExpInfoActionTypes.EDIT_CRED_EXP_INFO, [], error, 404, true, false));
    }
}

/**
 * Get Cred Expiry
 * @param {*}
 */
function* getCredExpInfo({ payload, type }: CredExpInfoData): SagaIterator {
    try {
        const response = yield call(getCredExpInfoApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                credExpInfoApiResponseSuccess(
                    CredExpInfoActionTypes.GET_CRED_EXP_INFO,
                    data,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Cred Expiry!`;
            if (message) msg = message;
            yield put(
                credExpInfoApiResponseSuccess(CredExpInfoActionTypes.GET_CRED_EXP_INFO, data, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(credExpInfoApiResponseError(CredExpInfoActionTypes.GET_CRED_EXP_INFO, [], error, 404, true, false));
    }
}

/**
 * Get Cred Expiry Info
 * @param {*}
 */
function* getCredExpInfos({ payload, type }: CredExpInfoData): SagaIterator {
    try {
        const response = yield call(getAllCredExpInfoApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                credExpInfoApiResponseSuccess(
                    CredExpInfoActionTypes.GET_CRED_EXP_INFOS,
                    responseData,
                    message,
                    code,
                    false,
                    false
                )
            );
        } else {
            let msg = `An error while getting Cred Expiry Info Listing!`;
            if (message) msg = message;
            yield put(
                credExpInfoApiResponseSuccess(
                    CredExpInfoActionTypes.GET_CRED_EXP_INFOS,
                    responseData,
                    msg,
                    code,
                    true,
                    false
                )
            );
        }
    } catch (error: any) {
        yield put(credExpInfoApiResponseError(CredExpInfoActionTypes.GET_CRED_EXP_INFOS, [], error, 404, true, false));
    }
}

export function* watchAddCredExpInfo() {
    yield takeEvery(CredExpInfoActionTypes.ADD_CRED_EXP_INFO, addCredExpInfo);
}

export function* watchEditCredExpInfo() {
    yield takeEvery(CredExpInfoActionTypes.EDIT_CRED_EXP_INFO, editCredExpInfo);
}

export function* watchGetCredExpInfo(): any {
    yield takeEvery(CredExpInfoActionTypes.GET_CRED_EXP_INFO, getCredExpInfo);
}

export function* watchGetCredExpInfos(): any {
    yield takeEvery(CredExpInfoActionTypes.GET_CRED_EXP_INFOS, getCredExpInfos);
}

function* credExpInfoSaga() {
    yield all([
        fork(watchAddCredExpInfo),
        fork(watchEditCredExpInfo),
        fork(watchGetCredExpInfo),
        fork(watchGetCredExpInfos),
    ]);
}

export default credExpInfoSaga;
